import { TrackEvent } from 'contexts/analytics/types';
import { PartnerNotesData } from 'store/partnerNotes';
import styles from '../Sidebar.module.css';
import { SidebarItemConfig } from '../useSidebarItems';

export function getPartnersRecsItemsDesktop(
  partnerNotesData: PartnerNotesData,
  trackEvent: TrackEvent,
): SidebarItemConfig[] {
  const sidebarItems: SidebarItemConfig[] = [];

  Object.values(partnerNotesData).forEach(pnd =>
    sidebarItems.push({
      to: `/partner-recs/${pnd.partner.id}`,
      label: `${pnd.partner.name} Recs`,
      icon: 'thumbStar',
      customClassName: styles.partnerRecsIcon,
      onClick: () => trackEvent('Partner Recs Nav Clicked'),
    }),
  );

  return sidebarItems;
}
